import TransfersPage from "components/pages/TransfersPage";

export default function CaptureQuickTourTransfer(props) {
    return <TransfersPage />
}